import { render, staticRenderFns } from "./alarmformnew.vue?vue&type=template&id=5b325e46&scoped=true&"
import script from "./alarmformnew.vue?vue&type=script&lang=js&"
export * from "./alarmformnew.vue?vue&type=script&lang=js&"
import style0 from "./alarmformnew.vue?vue&type=style&index=0&id=5b325e46&lang=less&scoped=true&"
import style1 from "./alarmformnew.vue?vue&type=style&index=1&lang=less&"
import style2 from "./alarmformnew.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b325e46",
  null
  
)

export default component.exports